export const services = [
  {
    title: "Website Development",
    text: "Fast, responsive websites built around your brand, your audience, and the action you want visitors to take.",
    icon: "01",
  },
  {
    title: "Mobile & Web Apps",
    text: "Customer apps, internal platforms, portals, and MVPs built for real-world use across phones, tablets, and desktops.",
    icon: "02",
  },
  {
    title: "Custom Software & IT Systems",
    text: "Purpose-built software, dashboards, APIs, workflows, and operational tools shaped around how your business actually works.",
    icon: "03",
  },
  {
    title: "AI Services & Automation",
    text: "Practical AI features, intelligent workflows, support tools, and automation that reduce repetitive work and improve speed.",
    icon: "04",
  },
  {
    title: "Product & UI/UX Design",
    text: "Clear product direction, polished interfaces, prototypes, and design systems that make complex ideas easier to understand.",
    icon: "05",
  },
  {
    title: "E-commerce & Digital Platforms",
    text: "Online stores, marketplaces, payment flows, account systems, catalogs, and scalable commerce experiences from end to end.",
    icon: "06",
  },
];

export const products = [
  {
    name: "RomBuzz",
    badge: "Live",
    description:
      "A real-time dating and social platform built around discovery, matching, chat, media, and meaningful connection.",
    url: "https://www.rombuzz.com",
    logo: "/rombuzz-logo.png",
    theme: "orange",
  },
  {
    name: "Yumi Beads",
    badge: "Live",
    description:
      "A modern commerce platform for curated fashion, accessories, gifts, and everyday products, powered by Neptrixx.",
    url: "https://www.yumibeads.com",
    logo: "/yumi-beads-logo.svg",
    theme: "blush",
  },
  {
    name: "MeetInTheMiddle",
    badge: "In development",
    description:
      "A meetup concept that finds a practical midpoint between two people and helps them discover places to meet.",
    url: "",
    logo: "",
    theme: "blue",
  },
  {
    name: "OverLimit",
    badge: "In development",
    description:
      "A driving-safety concept focused on speed-limit awareness and clearer real-time feedback behind the wheel.",
    url: "",
    logo: "",
    theme: "violet",
  },
  {
    name: "Nepal Commerce Hub",
    badge: "In development",
    description:
      "A marketplace ecosystem designed to bring independent sellers, social commerce, and established businesses together.",
    url: "",
    logo: "",
    theme: "mint",
  },
];

export const processSteps = [
  {
    title: "Understand",
    text: "We define the goal, audience, business problem, constraints, and what success should look like.",
  },
  {
    title: "Design",
    text: "We map the experience, simplify the flow, and create a visual direction that fits the product and brand.",
  },
  {
    title: "Build",
    text: "We develop the product, connect the systems, test across screens, and refine the details that affect quality.",
  },
  {
    title: "Launch & improve",
    text: "We deploy, monitor, support, and keep improving the product instead of disappearing after launch day.",
  },
];

export const stats = [
  { value: "2", label: "live products" },
  { value: "3", label: "products in development" },
  { value: "Worldwide", label: "client reach" },
];

export const inquiryServices = [
  "Website Development",
  "Web App Development",
  "Mobile App Development",
  "Custom Software / IT System",
  "AI Services & Automation",
  "E-commerce / Marketplace",
  "UI/UX & Product Design",
  "Maintenance & Support",
];
